import { render, staticRenderFns } from "./ChatItem.vue?vue&type=template&id=47792cec"
import script from "./ChatItem.vue?vue&type=script&lang=js"
export * from "./ChatItem.vue?vue&type=script&lang=js"
import style0 from "./ChatItem.vue?vue&type=style&index=0&id=47792cec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports